import React from 'react'
import { useAuthStore } from 'Store/Auth'
import { shallow } from 'zustand/shallow'
import { Navigate, Outlet } from 'react-router-dom'

interface Props {
  whitelist: number[]
  children?: React.ReactNode
}

const ProtectedRoutePermission: React.FC<Props> = ({ whitelist, children }) => {
  const hasFetchProfile = useAuthStore(state => state.hasFetchProfile, shallow)
  const roleId = useAuthStore(state => state.profile?.roleId ?? 0, shallow)

  if (!hasFetchProfile) {
    return null
  }

  if (whitelist.length > 0 && !whitelist.includes(roleId)) {
    return <Navigate to='/error/404' />
  } else {
    return (
      <React.Fragment>
        {children}
        <Outlet />
      </React.Fragment>
    )
  }
}

export default ProtectedRoutePermission
